// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8828cea0","453":"ee9d6033"}[chunkId] + ".chunk.js";
};